import { gql } from '@/__generated__';

export const deleteCustomerDocument = gql(/* GraphQL */ `
  mutation DeleteCustomer($where: CustomerWhereUniqueInput!) {
    deleteCustomer(where: $where) {
      id
      pageId
      name
      email
      avatar
      createdAt
      updatedAt
    }
  }
`);
